import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { storyblokEditable } from '@storyblok/react';
import React from 'react';
import { useIntl } from 'react-intl';

import useStoryblokImage from '../../../../util/hooks/useStoryblokImage';
import ProgressiveImage from '../../../Image/ProgressiveImage';
import Link from '../../../Links/Link/Link';

/**
 * @param {object} props
 * @param {object} props.blok
 */
const StoryblokLocationCard = ({ blok }) => {
  const intl = useIntl();

  const { title = '', subtitle = '', href = {}, image = {} } = blok;
  const { url = '', cached_url = '', linktype = '' } = href;
  const { filename, alt, title: imageTitle } = image;
  const { sources, src } = useStoryblokImage(filename, {
    size: 320,
  });

  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));

  const slug = (url || cached_url).replace(`/${intl.locale}/`, '').split('/')[0];
  const rest = (url || cached_url).replace(`/${intl.locale}/`, '').replace(`${slug}/`, '');
  const to =
    linktype === 'story'
      ? {
          name: 'StoryblokPage',
          params: { slug, rest },
        }
      : url || cached_url;

  return (
    <Link {...storyblokEditable(blok)} to={to} underline="none" width="100%">
      <Card sx={{ display: 'flex', width: '100%' }}>
        <CardMedia
          sx={{
            width: { xs: 110, md: 175 }, // Smaller width on extra-small devices
            height: { xs: 96, md: 120 }, // Smaller height on extra-small devices
          }}
        >
          <ProgressiveImage
            alt={alt}
            disableBlur
            height={isXs ? '96px' : '120px'}
            sources={sources}
            src={src}
            title={imageTitle}
          />
        </CardMedia>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '&:last-child': { p: 2 },
          }}
        >
          <Typography
            component="h3"
            sx={{
              margin: 0,
              fontSize: '1.25rem', // Adjust font size for md and lg breakpoints
            }}
            variant="h5"
          >
            {title}
          </Typography>
          <Typography
            color="text.secondary"
            component="h3"
            sx={{
              margin: 0,
              fontSize: '1rem', // Adjust font size for md and lg breakpoints
            }}
            variant="subtitle1"
          >
            {subtitle}
          </Typography>
        </CardContent>
      </Card>
    </Link>
  );
};

export default StoryblokLocationCard;
